module.exports = __webpack_public_path__ + "8028f7a1082d4b6a609f4c1f067223dd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-owlstagram/late-owl.png
// module id = 508
// module chunks = 0